export default {
  goalPostsTimestamp(state) {
    return state.goalPostsTimestamp;
  },
  companyReports(state) {
    return state.companyReports;
  },
  companyGoals(state) {
    return state.companyGoals;
  },
  departmentGoals(state) {
    return state.departmentGoals;
  },
  userReports(state) {
    return state.userReports;
  },
  userGoals(state) {
    return state.userGoals;
  },
};
